import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import { Box, Grid } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useMutation } from "react-query";
import {
  getNoticesResponse,
  noticeDetailRequest,
  updateSupplierNoticePinRequest,
} from "../../models/SupplierNotice.model";
import {
  GetCurrentNotices,
  GetNoticeDetail,
  UpdateSupplierNoticePin,
} from "../../services/SupplierNotice.service";
import ModalNotice from "../modals/ModalNotice";
import MoreDescription from "../../pages/notificationSupp/moreDescription";
// import LinesEllipsis from "react-line-ellipsis";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  // transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  //   transition: theme.transitions.create("transform", {
  //     duration: theme.transitions.duration.shortest,
  //   }),
}));

export default function NotificationSupp(props: any) {
  const [expanded, setExpanded] = React.useState(false);
  // const [pin, setPin] = React.useState( );
  const [openModal, setOpenModal] = React.useState(false);
  const [modalDetail, setModalDetail] = React.useState<getNoticesResponse[]>(
    []
  );

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const noticeId = new noticeDetailRequest();
  const handleOpenModal = (noticeKey: any) => {
    noticeId.noticeKey = noticeKey;
    if (noticeId && props.isLogin == false) {
      getNoticeDetailMutation.mutateAsync(noticeId);
    }
    if (props.isLogin == true) {
      setModalDetail(props.data);
      setOpenModal(true);
    }
  };
  const getNoticeDetailMutation = useMutation(GetNoticeDetail, {
    onSuccess: (data: getNoticesResponse[]) => {
      if (data) {
        setModalDetail(data);
        setOpenModal(true);
      }
    },
  });
  const getCurrentNoticeMutation = useMutation(GetCurrentNotices, {
    onSuccess: (data: getNoticesResponse[]) => {
      if (data) {
        props.setDataNotic(data);
      }
    },
  });

  const UpdateSupplierNoticePinMutation = useMutation(UpdateSupplierNoticePin, {
    onSuccess: (data: boolean) => {
      if (data) {
        getCurrentNoticeMutation.mutateAsync();
      }
    },
  });
  const updatePin = new updateSupplierNoticePinRequest();
  const handlePin = (noticeId: any) => {
    updatePin.noticeKey = noticeId;
    updatePin.isPinned = !props.data.isPinned;
    if (noticeId && props.isLogin == false) {
      UpdateSupplierNoticePinMutation.mutateAsync(updatePin);
    }
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, direction: "rtl" }}>
        <Grid
          className={
            props.data.noticeType == "Instant"
              ? "borderBeforCardImportant"
              : "borderBeforCardInfo"
          }
          container
          spacing={2}
          item
          xs={12}
        >
          <Grid
            item
            xs={8}
            className="cursorPointer"
            onClick={() => handleOpenModal(props.data.noticeKey)}
          >
            <b style={{ color: "#424242" }}>&nbsp;{props.data.title}</b>
          </Grid>
          <Grid
            item
            xs={4}
            className="cursorPointer"
            style={{ textAlign: "left" }}
            onClick={() => handlePin(props.data.noticeKey)}
          >
            {props.data.isPinned == true ? (
              <span
                className={
                  props.data.noticeType == "Instant"
                    ? "colorImportant"
                    : "colorInfo"
                }
              >
                {" "}
                <PushPinIcon />
              </span>
            ) : props.data.isPinned == false ? (
              <PushPinOutlinedIcon style={{ color: "#9AAFC4" }} />
            ) : null}
          </Grid>
          <Grid item xs={12} className="">
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <div
                // style={{ color: "#424242" }} moreText
                className=" cursorPointer"
                onClick={() => handleOpenModal(props.data.noticeKey)}
              >
                <MoreDescription text={props.data.rawBody} />
              </div>
            </Collapse>
          </Grid>
          <Grid item xs={4} className="mbottom5">
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <span style={{ fontSize: "12px" }} className="colorNoticeCard">
                {!expanded ? (
                  <span>
                    <ArrowDropDownIcon /> مشاهده بیشتر
                  </span>
                ) : (
                  <span>
                    {" "}
                    <ArrowDropUpIcon /> مشاهده کمتر
                  </span>
                )}
              </span>
            </ExpandMore>
          </Grid>

          <Grid
            item
            xs={8}
            className={`colorNoticeCard mbottom10`}
            style={{ textAlign: "left", marginTop: "6px" }}
          >
            <span>
              <b>{props.data?.noticeTypePersian}</b> &nbsp;
              {props.data?.creationDatePersian}
            </span>{" "}
            &nbsp; | &nbsp;
            <b>
              <AttachFileIcon /> {props.data.attachmentCount}
            </b>
          </Grid>
        </Grid>
        <ModalNotice
          openModel={openModal}
          setOpenModal={setOpenModal}
          detail={modalDetail}
          isLogin={props.isLogin}
          FNsetPinColor={null}
          FNsetViewDate={null}
        />
      </Box>
    </>
  );
}
